<template>
  <div class="money">
    <headers></headers>
    <div class="banner">
      <el-row class="bannerinfo">
        <el-col :span="12" :offset="1">
          <div class="content">
            <p>智能收银机</p>
            <p>
              <img src="../assets/线1@2x.png" alt />
            </p>
            <p>经理云生态管理平台</p>
            <p>
              <img src="../assets/线1@2x.png" alt />
            </p>
            <p>专注为眼镜行业的收银管理平台</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 移动端头部 -->
    <div class="smallbanner">
      <img src="../assets/images/homeImg/banner.png" width="100%" alt />
    </div>
    <main>
      <el-row class="main-top">
        <el-col :span="24">
          <div class="content_m">
            <h2 style="font-size:36px;margin-top:91px">产品功能</h2>
            <p style="font-size: 16px;margin-top:18px">PRODUCT FUNCTION</p>
            <p>&nbsp;</p>
            <p style="font-size: 28px;margin-top:56px">智能收银机</p>
            <p style="font-size: 18px;margin-top:19px;margin-bottom:40px">便捷收银操作/每一笔销售统一入账/科学店务管理</p>
            <p>&nbsp;</p>
            <p>
              <img src="../assets/onetu.png" alt width="640px;" />
            </p>
          </div>
        </el-col>
      </el-row>
      <!-- 移动端 -->
      <div class="smallmain-top">
        <h2>产品功能</h2>
        <div class="smallmain-img">
          <img src="../assets/onetu.png" alt />
        </div>
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="slidebox">
                <p>
                  <i class="el-icon-circle-check"></i>互联网+模式
                </p>
                <p>收银机端 网页端</p>
                <p>移动端 相辅相成</p>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="slidebox">
                <p>
                  <i class="el-icon-circle-check"></i>激活码加密
                </p>
                <p>本地云端双备份</p>
                <p>数据安全无丢失</p>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="slidebox">
                <p>
                  <i class="el-icon-circle-check"></i>数据实时更新
                </p>
                <p>相关信息及时推送</p>
                <p>运营状况随时查</p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>

      <el-row class="main-but" style="margin:40px 0">
        <el-col :span="16" :offset="4">
          <div class="content_b">
            <el-carousel indicator-position="outside" height="150px">
              <el-carousel-item>
                <el-row>
                  <el-col :span="8">
                    <div class="box">
                      <p style="font-size: 30px;">
                        <i
                          class="el-icon-circle-check"
                          style="color:#258FFC;font-size: 28px;margin-right:10px;"
                        ></i>互联网+模式
                      </p>
                      <p>&nbsp;</p>
                      <p>收银机端 网页端</p>
                      <p>移动端 相辅相成</p>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="box">
                      <p style="font-size: 30px;">
                        <i
                          class="el-icon-circle-check"
                          style="color:#258FFC;font-size: 28px;margin-right:10px;"
                        ></i>激活码加密
                      </p>
                      <p>&nbsp;</p>
                      <p>本地云端双备份</p>
                      <p>数据安全无丢失</p>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="box">
                      <p style="font-size: 30px;">
                        <i
                          class="el-icon-circle-check"
                          style="color:#258FFC;font-size: 28px;margin-right:10px;"
                        ></i>数据实时更新
                      </p>
                      <p>&nbsp;</p>
                      <p>相关信息及时推送</p>
                      <p>运营状况随时查</p>
                    </div>
                  </el-col>
                </el-row>
              </el-carousel-item>
              <el-carousel-item>
                <el-row>
                  <el-col :span="8">
                    <div class="box">
                      <p style="font-size: 30px;">
                        <i
                          class="el-icon-circle-check"
                          style="color:#258FFC;font-size: 28px;margin-right:10px;"
                        ></i>互联网+模式
                      </p>
                      <p>&nbsp;</p>
                      <p>收银机端 网页端</p>
                      <p>移动端 相辅相成</p>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="box">
                      <p style="font-size: 30px;">
                        <i
                          class="el-icon-circle-check"
                          style="color:#258FFC;font-size: 28px;margin-right:10px;"
                        ></i>激活码加密
                      </p>
                      <p>&nbsp;</p>
                      <p>本地云端双备份</p>
                      <p>数据安全无丢失</p>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="box">
                      <p style="font-size: 30px;">
                        <i
                          class="el-icon-circle-check"
                          style="color:#258FFC;font-size: 28px;margin-right:10px;"
                        ></i>数据实时更新
                      </p>
                      <p>&nbsp;</p>
                      <p>相关信息及时推送</p>
                      <p>运营状况随时查</p>
                    </div>
                  </el-col>
                </el-row>
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-col>
      </el-row>
    </main>
    <div class="jisu">
      <el-row class="jisu-top">
        <el-col :span="24">
          <div class="content_m">
            <h2 style="font-size:28px;margin-bottom:19px">收银机 技术规格</h2>
            <p style="font-size: 18px;">全功能触摸一体收银机</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p style="margin-top:50px;">
              <img src="../assets/tu3@2x.png" alt width="580px;" />
            </p>
          </div>
        </el-col>
      </el-row>
      <!-- 移动端头部 -->
      <div class="smalljisu">
        <h2>技术规格</h2>
        <div class="smalljisu-img">
          <img src="../assets/tu3@2x.png" alt />
        </div>
      </div>

      <el-row class="jisu-bot">
        <el-col :lg="{span:16,offset:4}" :md="{span:24,offset:0}">
          <el-row>
            <div class="box">
              <el-col :span="4" :offset="1">
                <div class="boxInfo">
                  <p>主显示屏</p>
                  <p>1.56寸</p>
                  <p>电容触摸</p>
                </div>
              </el-col>
              <el-col :span="4" :offset="2">
                <div class="boxInfo">
                  <p>客显</p>
                  <p>9寸</p>
                  <p>宽视角</p>
                </div>
              </el-col>
              <el-col :span="4" :offset="2">
                <div class="boxInfo">
                  <p>主频</p>
                  <p>1.8GHZ</p>
                  <p>处理器</p>
                </div>
              </el-col>
              <el-col :span="4" :offset="2">
                <div class="boxInfo">
                  <p>打印速度</p>
                  <p>260mm</p>
                  <p>每秒</p>
                </div>
              </el-col>
            </div>
          </el-row>
        </el-col>
      </el-row>
      <!-- 移动端 -->
      <div class="smalljisu-bot">
        <div class="swiper-container1">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="slidebox">
                <p>主显示屏</p>
                <p>1.56寸</p>
                <p>电容触摸</p>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="slidebox">
                <p>客显</p>
                <p>9寸</p>
                <p>宽视角</p>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="slidebox">
                <p>主频</p>
                <p>1.8GHZ</p>
                <p>处理器</p>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="slidebox">
                <p>打印速度</p>
                <p>260mm</p>
                <p>每秒</p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination1"></div>
      </div>
    </div>
    <div class="peizhi">
      <div class="peizhi-top">
        <h2>一体式收银机</h2>
      </div>
      <el-row>
        <el-col :span="5" :offset="4" :xs="{span:24,offset:0}">
          <div class="contents">
            <img src="../assets/onetu.png" alt width="479px;" />
          </div>
        </el-col>
        <el-col :span="2" :offset="2">&nbsp;</el-col>
        <el-col :span="6" :xs="{span:24}">
          <div class="contents" style="padding: 10px 40px;">
            <p>系统：Andriod6.0.1</p>
            <p>CPU：rk3288 4核 A17</p>
            <p>内存：2G</p>
            <p>闪存：8G</p>
            <p>通讯：以太网/WiFi/蓝牙</p>
            <p>内置打印机装纸容量：80mm</p>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" class="baba">
          <div class="yyy">
            <img src="../assets/材料@2x.png" alt />
            <span>主显示屏采用军工级别铝合金材料</span>
          </div>
          <div class="yyy">
            <img src="../assets/塑料@2x.png" alt />
            <span>主显示屏采用军工级别铝合金材料</span>
          </div>
          <div class="yyy">
            <img src="../assets/小票打印机@2x.png" alt />
            <span>主显示屏采用军工级别铝合金材料</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="proto">
      <div class="smallproto">
        <h2>样机细节展示</h2>
      </div>
      <el-row class="proto_top">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <h4>样机细节展示</h4>
            <p>带给您不一样的视觉体验</p>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <div class="proto_b">
            <img src="../assets/yangji.png" alt />
            <br />
            <img src="../assets/1Pro3-1@2x.png" width="620px" alt />
            <br />
            <img src="../assets/1Pro3-2@2x.png" width="620px" alt />
            <br />
            <img src="../assets/1Pro3-3@2x.png" width="620px" alt />
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="genduo">
      <el-row>
        <el-col :span="24">
          <div class="genduo_b">
            <p>查看更多收银机的配置</p>
            <p>带给您最优质的产品和最贴心的服务</p>
            <p>
              <button @click="$router.push('/dispose')">了解详情</button>
            </p>
          </div>
        </el-col>
      </el-row>
    </div>
    <footers></footers>
  </div>
</template>

<script>
import header from "../components/headers";
import footer from "../components/footer";
import Swiper from "swiper";
import "../../node_modules/swiper/dist/css/swiper.min.css";
export default {
  mounted() {
    var mySwiper = new Swiper(".swiper-container", {
      pagination: {
        el: ".swiper-pagination"
      },
      slidesPerView: 2
    });
    var mySwiper = new Swiper(".swiper-container1", {
      pagination: {
        el: ".swiper-pagination1"
      },
      slidesPerView: 2
    });
  },
  components: {
    headers: header,
    footers: footer
  }
};
</script>

<style lang="less" scoped>
.money {
  @media screen and (max-width: 850px) {
    .banner {
      display: none;
    }
    main {
      .main-top {
        display: none;
      }
      .main-but {
        display: none;
      }
    }
  }
  @media screen and (min-width: 850px) {
    .smallbanner {
      display: none;
    }
    main {
      .smallmain-top {
        display: none;
      }
      .smallmain-but {
        display: none;
      }
    }
  }
  .banner {
    background: url("../assets/syj.png") no-repeat center center;
  }
  .content {
    padding: 125px 0;
    text-align: center;
    color: #fff;
    p {
      // padding: 10px 0;
      // overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 50px;

      &:nth-of-type(1) {
        font-size: 60px;
        font-family: MicrosoftYaHei;
      }
      &:nth-of-type(3) {
        font-size: 72px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
      }
      &:nth-of-type(5) {
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 24px;
      }
      @media screen and (max-width: 1300px) {
        &:nth-of-type(1) {
          font-size: 50px;
        }
        &:nth-of-type(3) {
          font-size: 60px;
        }
        &:nth-of-type(5) {
          font-size: 18px;
        }
      }
    }
  }
  main {
    padding-bottom: 30px;
    .content_m {
      text-align: center;
      p {
        line-height: 25px;
      }
    }
    .content_b {
      text-align: center;
      font-size: 20px;
    }
    .smallmain-top {
      h2 {
        font-size: 16px;
        color: #2e2e2e;
        font-weight: 400;
        margin: 11px 0;
        position: relative;
        padding-left: 28px;

        &::after {
          content: "";
          background-color: #258ffc;
          border-radius: 5.5px;
          width: 4px;
          height: 16px;
          overflow: hidden;
          position: absolute;
          top: 3px;
          left: 13px;
        }
      }
      .smallmain-img {
        width: 100%;
        text-align: center;
        margin-top: 20px;
        img {
          width: 60%;
        }
      }
      .swiper-container {
        margin-top: 30px;
      }
      .swiper-slide {
        // padding-left: 30px;
        text-align: center;
        .slidebox {
          p {
            font-size: 11px;
            &:nth-of-type(1) {
              font-size: 14px;
              font-weight: 600;
              i {
                color: #258ffc;
                font-size: 15px;
                margin-right: 5px;
              }
            }
          }
        }
      }
      .swiper-pagination {
        width: 100%;
        /deep/.swiper-pagination-bullet {
          height: 2px;
        }
      }
    }
  }
  .jisu {
    background-color: #f0efef;
    text-align: center;
    padding: 40px 0;

    @media screen and (max-width: 850px) {
      .jisu-top {
        display: none;
      }
      .jisu-bot {
        display: none;
      }
    }
    @media screen and (min-width: 850px) {
      .smalljisu {
        display: none;
      }
      .smalljisu-bot {
        display: none;
      }
    }
    .smalljisu {
      h2 {
        font-size: 16px;
        color: #2e2e2e;
        font-weight: 400;
        margin: 11px 0;
        position: relative;
        padding-left: 28px;
        text-align: left;
        &::after {
          content: "";
          background-color: #258ffc;
          border-radius: 5.5px;
          width: 4px;
          height: 16px;
          overflow: hidden;
          position: absolute;
          top: 3px;
          left: 13px;
        }
      }
      .smalljisu-img {
        width: 100%;
        text-align: center;
        margin-top: 20px;
        img {
          width: 60%;
        }
      }
    }
    .smalljisu-bot {
      margin-top: 20px;
      .slidebox {
        p {
          font-size: 12px;
          &:nth-of-type(2) {
            font-size: 25px;
            color: #258ffc;
            font-weight: 600;
          }
        }
      }
      .swiper-pagination1 {
        width: 100%;
        /deep/.swiper-pagination-bullet {
          height: 2px;
        }
      }
    }
    .boxInfo {
      color: #666;
      cursor: pointer;
      width: 270px;
      height: 150px;
      padding: 15px 0;
      &:hover {
        box-shadow: 0px 2px 7px #e2e1e2;
        p {
          &:nth-child(2) {
            color: #258ffc;
          }
        }
      }
      p {
        line-height: 28px;
        font-size: 20px;
        color: #666;
        &:nth-child(2) {
          font-size: 48px;
          font-weight: 800;
          font-family: Arial-BoldMT;
          margin: 16px 0;
        }
      }
    }
  }
  .peizhi {
    text-align: center;
    padding: 100px 0;
    @media screen and (min-width: 850px) {
      .peizhi-top {
        display: none;
      }
    }
    @media screen and (max-width: 850px) {
      padding: 20px 0;
    }
    .peizhi-top {
      h2 {
        font-size: 16px;
        color: #2e2e2e;
        font-weight: 400;
        margin: 11px 0;
        position: relative;
        padding-left: 28px;
        text-align: left;
        &::after {
          content: "";
          background-color: #258ffc;
          border-radius: 5.5px;
          width: 4px;
          height: 16px;
          overflow: hidden;
          position: absolute;
          top: 3px;
          left: 13px;
        }
      }
    }
    .contents {
      @media screen and (max-width: 850px) {
        text-align: center;
        img {
          width: 60%;
        }
        p {
          line-height: 22px !important;
          height: 22px !important;
          font-size: 12px !important;
        }
      }
      span {
        width: 2px;
        height: 400px;
        background-color: #ccc;
        display: block;
        margin: 0 auto;
      }
      p {
        width: 320px;
        height: 70px;
        text-align: left;
        line-height: 70px;
        cursor: pointer;
        padding: 0 20px;
        font-size: 20px;
        white-space: nowrap;
        &:hover {
          box-shadow: 0px 2px 7px #e2e1e2;
          color: #258ffc;
          font-weight: 800;
        }
      }
    }
    .baba {
      margin: 80px 0 20px 0;
      font-size: 18px;
      display: flex;
      justify-content: center;
      @media screen and (max-width: 850px) {
        flex-direction: column;
        margin: 0;
        .yyy {
          img {
            width: 15px !important;
          }
          span {
            font-size: 12px;
          }
        }
      }
      .yyy {
        padding: 10px 0;
        cursor: pointer;
        transition: all 1s;
        float: left;
        margin-right: 58px;
        &:hover {
          transform: translateY(-4px);
        }
        img {
          width: 20px;
          margin-right: 5px;
          vertical-align: middle;
        }
        span {
          color: #2891fc;
          vertical-align: middle;
        }
      }
    }
  }
  .proto {
    background-color: #fff;
    padding: 40px 0;
    .smallproto {
      @media screen and (min-width: 850px) {
        display: none;
      }
      h2 {
        font-size: 16px;
        color: #2e2e2e;
        font-weight: 400;
        margin: 11px 0;
        position: relative;
        padding-left: 28px;

        &::after {
          content: "";
          background-color: #258ffc;
          border-radius: 5.5px;
          width: 4px;
          height: 16px;
          overflow: hidden;
          position: absolute;
          top: 3px;
          left: 13px;
        }
      }
    }
    .proto_top {
      text-align: center;
      margin: 40px 0;
      margin-top: -20px;
      h4 {
        font-weight: 400;
        font-size: 28px;
        margin-bottom: 19px;
        margin-top: 30px;
      }
      p {
        font-size: 18px;
      }
      @media screen and (max-width: 850px) {
        h4 {
          font-size: 14px;
          margin-bottom: 9px;
        }
        p {
          font-size: 9px;
        }
      }
    }
    .proto_b {
      text-align: center;
      @media screen and (max-width: 850px) {
        img {
          width: 100%;
          &:nth-of-type(1) {
            width: 70%;
          }
        }
      }

      img {
        margin: 40px 0;
        transition: all 1s;
        cursor: pointer;
        &:hover {
          transform: scale(1.2);
        }
      }
    }
  }
  .genduo {
    height: 680px;
    background: url("../assets/last.png") no-repeat center center;
    padding: 50px 0;
    @media screen and (max-width: 850px) {
      height: unset;
    }
    .genduo_b {
      text-align: center;
      p {
        color: #fff;
        line-height: 40px;
        &:nth-of-type(1) {
          font-size: 36px;
          margin-top: 70px;
        }
        &:nth-of-type(2) {
          font-size: 18px;
          margin-top: 20px;
        }
        @media screen and (max-width: 850px) {
          line-height: 20px;
          &:nth-of-type(1) {
            font-size: 20px;
            margin-top: 30px;
          }
          &:nth-of-type(2) {
            font-size: 12px;
            margin-top: 5px;
          }
        }
      }
      button {
        outline: none;
        border: 0;
        background-color: #ffff00;
        width: 150px;
        height: 50px;
        cursor: pointer;
        // border-radius: 5px;
        font-size: 18px;
        color: #323232;
        margin-top: 27px;
        &:hover {
          background-color: rgb(248, 248, 116);
        }
        @media screen and (max-width: 850px) {
          width: 75px;
          height: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>